import { render, staticRenderFns } from "./PartCkuPrvsSearch.vue?vue&type=template&id=72cc7408&"
import script from "./PartCkuPrvsSearch.vue?vue&type=script&lang=js&"
export * from "./PartCkuPrvsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports